// extracted by mini-css-extract-plugin
export default {"wrap":"hI-z","subtitle":"iI-z","contentWrap":"jI-z","imgWrap":"kI-z","heading":"lI-z","copy":"mI-z"};